import 'console/tabs/graphs/components/graph/_timegraph.sass';
import * as $ from 'jquery';
import 'jquery-mousewheel';
import 'webui/lib/jquery.flot.mod';
import 'webui/lib/jquery.flot.time';
import 'webui/lib/jquery.flot.crosshair';
import 'webui/lib/jquery.flot.selection.mod';
import 'webui/lib/jquery.flot.curvedLines';
import { createSpinner } from 'console/utils/create-spinner';
import { visual_downsample } from 'console/tabs/graphs/downsample';
import is_touch from 'console/utils/is-touch';
import { ResizeSensor } from 'css-element-queries';
import { rusTimeDateBr, rusTimeOnly } from 'webui/utils/time';
import { throttle } from 'throttle-debounce';
const is_mobile = Math.min(screen.width, screen.height) <= 480;
export default class TimeGraph {
    _zoom_factor = 1.5;
    _size_boolean_line = 5;
    _bool_graph_on_main;
    axes_font;
    _interaction_end;
    _set_hover;
    _interaction_start;
    _set_unhover;
    _view_port_change;
    _bounds;
    _viewport;
    _element;
    _selection_mode;
    _markings;
    _bottom_markings;
    _yBounds;
    _loading;
    _wheel_zoom;
    _touches;
    _object_touches;
    _plotElement;
    _spinner_container;
    _graphData;
    _plot;
    _canvas;
    _spinner;
    _booleanPlotElement;
    _left_margin_for_boolean;
    _booleanPlot;
    _resize_sensor;
    constructor(interaction_end, set_hover, view_port_change, interaction_start, set_unhover) {
        this.axes_font = {
            size: is_mobile ? 11 : 13,
            lineHeight: is_mobile ? 11 : 13,
            weight: 'normal',
            color: '#545454',
        };
        this._interaction_end = interaction_end;
        this._set_hover = set_hover;
        this._interaction_start = interaction_start;
        this._set_unhover = set_unhover;
        this._view_port_change = view_port_change;
        this._bounds = null;
        this._viewport = null;
        this._object_touches = {};
        this._left_margin_for_boolean = 0;
        this._selection_mode = false;
        this._markings = [];
        this._bottom_markings = [];
        this._yBounds = null;
        this._loading = false;
        this._wheel_zoom = true;
        this._graphData = [];
        this._booleanPlot = null;
        this._plot = null;
        this._canvas = null;
        this._spinner = createSpinner({ zIndex: 1 });
        this._resize_sensor = null;
        this._element = $(`
            <div class="ui-graph-container">
                <div class="ui-time-graph">
                    <div class="ui-time-graph-plot">
                    </div>
                </div>
                <div class="ui-boolean-time-graphs">
                    <div class="ui-boolean-graphs"></div>
                    <div class="ui-boolean-yaxis">
                    </div>
                </div>
                <div class="ui-time-graph-spinner-container"></div>
            </div>
        `);
        this._plotElement = this._element
            .children('.ui-time-graph')
            .children('.ui-time-graph-plot')
            .on('wheel', this._onWheel)
            .on('plothover', this._onHover)
            .on('plotclick', this._onHover)
            .on('mouseout', this._onUnhover)
            .on('plotselected', this._onSelected)
            .on('dblclick', (event) => {
            const pos = this._coordsByMouse(event);
            if (pos)
                this._zoomStep(-1, pos.x, {
                    pageX: event.pageX,
                    pageY: event.pageY,
                    x: pos.x,
                    y: pos.y,
                });
        });
        this._booleanPlotElement = this._element
            .children('.ui-boolean-time-graphs')
            .children('.ui-boolean-graphs')
            .on('wheel', this._onWheel)
            .on('plothover', this._onHover)
            .on('plotclick', this._onHover)
            .on('mouseout', this._onUnhover)
            .on('plotselected', this._onSelected)
            .on('dblclick', (event) => {
            const pos = this._coordsByMouse(event);
            if (pos)
                this._zoomStep(-1, pos.x, {
                    pageX: event.pageX,
                    pageY: event.pageY,
                    x: pos.x,
                    y: pos.y,
                });
        });
        if (is_touch) {
            this._plotElement
                .on('touchstart', (event) => {
                const touches = event.originalEvent?.changedTouches;
                if (touches)
                    for (let i = 0, len = touches.length; i < len; i++) {
                        this._touchStart(touches[i].identifier, touches[i].pageX, touches[i].pageY);
                    }
            })
                .on('touchmove', throttle(200, (event) => {
                const touches = event.originalEvent?.changedTouches;
                if (touches)
                    for (let i = 0, len = touches.length; i < len; i++) {
                        const touch = touches[i];
                        const identifier = touch.identifier.toString();
                        if (identifier in this._object_touches) {
                            this._object_touches[touch.identifier].x =
                                touch.pageX;
                            this._object_touches[touch.identifier].y =
                                touch.pageY;
                        }
                    }
                if (this._touchUpdate(event)) {
                    event.preventDefault();
                }
            }))
                .on('touchend touchleave touchcancel', (event) => {
                //@ts-ignore
                const touches = event.originalEvent?.changedTouches;
                for (let i = 0, len = touches.length; i < len; i++)
                    this._touchEnd(touches[i].identifier);
            });
            this._booleanPlotElement
                .on('touchstart', (event) => {
                const touches = event.originalEvent?.changedTouches;
                if (touches)
                    for (let i = 0, len = touches.length; i < len; i++) {
                        this._touchStart(touches[i].identifier, touches[i].pageX, touches[i].pageY);
                    }
            })
                .on('touchmove', throttle(200, (event) => {
                const touches = event.originalEvent?.changedTouches;
                if (touches)
                    for (let i = 0, len = touches.length; i < len; i++) {
                        const touch = touches[i];
                        const identifier = touch.identifier.toString();
                        if (identifier in this._object_touches) {
                            this._object_touches[touch.identifier].x =
                                touch.pageX;
                            this._object_touches[touch.identifier].y =
                                touch.pageY;
                        }
                    }
                if (this._touchUpdate(event)) {
                    event.preventDefault();
                }
            }))
                .on('touchend touchleave touchcancel', (event) => {
                //@ts-ignore
                const touches = event.originalEvent?.changedTouches;
                for (let i = 0, len = touches.length; i < len; i++)
                    this._touchEnd(touches[i].identifier);
            });
        }
        else {
            this._plotElement
                .on('mousedown', (event) => {
                if (event.which != 1 || event.ctrlKey || this.selection_mode()) {
                    // Make Flot handle this event to make range selection work
                    return false;
                }
                this._touchStart(0, event.pageX, event.pageY);
                return true;
            })
                .on('mousemove', throttle(200, (event) => {
                if (this._object_touches?.[0]) {
                    this._object_touches[0].x = event.pageX;
                    this._object_touches[0].y = event.pageY;
                    this._touchUpdate(event);
                }
            }))
                .on('mouseup', (event) => {
                this._touchEnd(0);
            });
            this._booleanPlotElement
                .on('mousedown', (event) => {
                if (event.which != 1 || event.ctrlKey || this.selection_mode()) {
                    // Make Flot handle this event to make range selection work
                    return false;
                }
                this._touchStart(0, event.pageX, event.pageY);
                return true;
            })
                .on('mousemove', throttle(100, (event) => {
                if (this._object_touches?.[0]) {
                    this._object_touches[0].x = event.pageX;
                    this._object_touches[0].y = event.pageY;
                    this._touchUpdate(event);
                }
            }))
                .on('mouseup', (event) => {
                this._touchEnd(0);
            });
        }
        this._spinner_container = this._element.find('.ui-time-graph-spinner-container');
        const GetEl = this._element.get(0);
        if (GetEl) {
            this._resize_sensor = new ResizeSensor(GetEl, () => {
                this.redraw();
            });
        }
    }
    customizePlot = (series, options) => options;
    get_yBounds = () => this._yBounds;
    set_yBounds = (value) => {
        this._yBounds = value;
    };
    set_SizeBooleanLine = (value) => (this._size_boolean_line = value);
    get_SizeBooleanLine = () => this._size_boolean_line;
    set_boolGraphOnMain = (value) => (this._bool_graph_on_main = value);
    setLeftMarginForBoolean = (value) => {
        this._left_margin_for_boolean = value;
    };
    get_count_boolean_lines = () => {
        return this._bottom_markings.length + this._markings.length;
    };
    wheel_zoom = () => this._wheel_zoom;
    set_wheel_zoom = (value) => {
        this._wheel_zoom = value;
    };
    selection_mode = () => this._selection_mode;
    set_selection_mode = (value) => {
        if (this._selection_mode == value)
            return;
        this._selection_mode = value;
        this._plotElement?.toggleClass('selection-mode', value);
        this._booleanPlotElement.toggleClass('selection-mode', value);
    };
    bottom_markings = () => this._bottom_markings;
    set_bottom_markings = (value, dont_redraw) => {
        this._bottom_markings = value;
        if (!dont_redraw)
            this.redraw();
    };
    markings = () => this._markings;
    set_markings = (value, dont_redraw) => {
        this._markings = value;
        if (!dont_redraw)
            this.redraw();
    };
    bounds = () => this._bounds;
    set_bounds = (value) => {
        this._bounds = value;
    };
    loading = () => this._loading;
    set_loading = (value) => {
        this._loading = value;
        this._element?.toggleClass('ui-time-graph-loading', !!value);
        this._spinner_container.toggleClass('visible', !!value);
        if (value) {
            this._spinner.spin(this._spinner_container.get(0));
        }
        else {
            this._spinner.stop();
        }
    };
    viewport = () => this._viewport;
    set_viewport = (value, no_event) => {
        if (!this._bounds)
            return;
        let a = parseInt(value[0].toString(), 10);
        let b = parseInt(value[1].toString(), 10);
        if (b - a >= 60 * 1000) {
            if (b - a > this._bounds[1] - this._bounds[0]) {
                const mid = (b + a) / 2;
                const width = this._bounds[1] - this._bounds[0];
                a = mid - width / 2;
                b = mid + width / 2;
            }
            this._viewport = [a, b];
            if (a < this._bounds[0]) {
                const overshoot = this._bounds[0] - a;
                this._viewport[0] += overshoot;
                this._viewport[1] += overshoot;
            }
            if (b > this._bounds[1]) {
                const overshoot = b - this._bounds[1];
                this._viewport[0] -= overshoot;
                this._viewport[1] -= overshoot;
            }
        }
    };
    element = () => this._element;
    destroy = () => {
        this._plot = null;
        delete this._graphData;
        this._plotElement = $();
        this._element?.remove();
        this._element = $();
        this._booleanPlotElement = $();
    };
    setGraphData = (bounds, data) => {
        this._bounds = [
            bounds[0] instanceof Date ? bounds[0].getTime() : bounds[0],
            bounds[1] instanceof Date ? bounds[1].getTime() : bounds[1],
        ];
        this._viewport = [this._bounds[0], this._bounds[1]];
        this._markings = [];
        this._graphData = data;
    };
    replaceGraphData = (data) => {
        this._graphData = data;
    };
    getGraphData = () => this._graphData;
    redraw = (block_offset) => {
        if (!this._viewport)
            return;
        if (block_offset) {
            const areaScrollTop = $('.ui-graphs-tab-scrolling-area').scrollTop();
            const areaHeight = $('.ui-graphs-tab-scrolling-area').height();
            const offsetTop = $('.ui-graphs-tab-scrolling-area').offset()?.top;
            if (areaHeight && areaScrollTop && offsetTop) {
                if (!(block_offset.top <= areaHeight + areaScrollTop + offsetTop &&
                    block_offset.bottom >= offsetTop)) {
                    return;
                }
            }
        }
        // Dirty hack until this code is rewritten with React
        //@ts-ignore
        const theme = window._ui?.getUITheme();
        const options = {
            xaxis: {
                mode: 'time',
                min: this._viewport[0],
                max: this._viewport[1],
                //цвета вертикальных полосочек
                color: theme != null
                    ? theme.palette.mode === 'dark'
                        ? theme.palette.grey['600']
                        : '#e4e4e4'
                    : '#e4e4e4',
                font: theme != null
                    ? {
                        ...this.axes_font,
                        color: theme.palette.mode === 'dark'
                            ? theme.palette.text.secondary
                            : '#545454',
                    }
                    : this.axes_font,
                tickFormatter: (time, axis) => {
                    const d = new Date(time);
                    const p = axis._prev;
                    axis._prev = d;
                    if (p && d > p.getTime()) {
                        if (d.getFullYear() - 1900 == p.getFullYear() - 1900 &&
                            d.getMonth() == p.getMonth() &&
                            d.getDate() == p.getDate() &&
                            p.getTime() > axis.min)
                            if (d.getHours() == p.getHours() &&
                                d.getMinutes() == p.getMinutes())
                                return '';
                            else
                                return rusTimeOnly(d);
                        else
                            return rusTimeDateBr(d);
                    }
                    else
                        return rusTimeDateBr(d);
                },
            },
            yaxis: {
                //цвета горизонтальных полосочек
                tickColor: theme != null
                    ? theme.palette.mode === 'dark'
                        ? theme.palette.grey['600']
                        : '#e4e4e4'
                    : '#e4e4e4',
                color: 'red',
                font: theme != null
                    ? {
                        ...this.axes_font,
                        color: theme.palette.mode === 'dark'
                            ? theme.palette.text.secondary
                            : '#545454',
                    }
                    : this.axes_font,
            },
            grid: {
                borderWidth: 0,
                hoverable: true,
                clickable: is_touch,
                autoHighlight: false,
                backgroundColor: theme != null && theme.palette.mode === 'dark' ? '#545454' : '#fff',
                markingsColor: 'rgba(128, 128, 128, 0.12)',
            },
            crosshair: {
                mode: 'xy',
                color: theme != null ? theme.palette.primary.dark : '#007d99',
                lineWidth: 1.5,
                locked: true,
                intermittent: true,
            },
            selection: {
                mode: 'x',
                color: '#4e9dd5',
                filter_func: (e) => {
                    return e.ctrlKey || this.selection_mode();
                },
                on_selection_start: () => {
                    this._plotElement?.addClass('selecting');
                },
                on_selection_stop: () => {
                    this._plotElement?.removeClass('selecting');
                },
            },
        };
        if (this._yBounds && options.yaxis) {
            options.yaxis.min = this._yBounds[0];
            options.yaxis.max = this._yBounds[1];
        }
        if (this._plotElement?.width() && this._plotElement?.height()) {
            let max_x = null, max_y = null, min_x = null, min_y = null;
            this._realPlot(options);
            if (this._plot) {
                for (const axis of this._plot.getYAxes()) {
                    if (axis.box && (axis.show || axis.reserveSpace)) {
                        if (min_x == null || axis.box.left < min_x)
                            min_x = axis.box.left;
                        if (min_y == null || axis.box.top < min_y)
                            min_y = axis.box.top;
                        if (max_x == null || axis.box.left + axis.box.width > max_x)
                            max_x = axis.box.left + axis.box.width;
                        if (max_y == null || axis.box.top + axis.box.height > max_y)
                            max_y = axis.box.top + axis.box.height;
                    }
                }
            }
            this._element?.find('.ui-graph-block-yaxis-glass').css({
                //@ts-ignore
                display: min_x != null ? 'block' : 'none',
                left: min_x,
                top: min_y,
                width: max_x != null && min_x != null ? max_x - min_x : null,
                height: max_y != null && min_y != null ? max_y - min_y : null,
            });
            if (!this._plot) {
                this._element.height(this._booleanPlotElement?.height() ?? 0);
            }
        }
        const boolean_not_on_main = !this._bool_graph_on_main &&
            this._bottom_markings.length + this._markings.length > 0;
        const many_boolean = this._bottom_markings.length + this._markings.length > 1;
        if (this._booleanPlotElement.width() &&
            (boolean_not_on_main || many_boolean || this._booleanPlot != null)) {
            this._realBooleanPlot();
        }
    };
    //Перевод наших булевых значений
    //Когда нам нужно отобразить только одно булевое значение на основном графике
    getGridMarkings = (array) => {
        const result_array = [];
        for (const element of array) {
            if (element.data.length != 0) {
                for (const data_element of element.data) {
                    if (data_element)
                        result_array.push(data_element);
                }
            }
        }
        return result_array;
    };
    _realPlot = (options) => {
        let series = [];
        const graph_width = this._plotElement?.width();
        if (this._graphData)
            for (let i = 0; i < this._graphData.length; i++) {
                const elem = this._graphData[i];
                if (elem && elem.show == false)
                    continue;
                const s = $.extend({}, elem);
                // if (s.strip)
                //     s.data = this._stripGraphData(this._graphData[i].data, this._viewport, this._plotElement.width())
                if (!s.dont_downsample && this._viewport && graph_width) {
                    s.data = visual_downsample(s.data, this._viewport, graph_width);
                }
                series.push(s);
            }
        //Проверяем, если у вас нет данных в series и при этом должны быть отрисованы какие либо булевые графики, то основной график скрываем
        //булевый график с отображением на основном графике
        const one_boolean_on_main = series.length === 0 &&
            !this._bool_graph_on_main &&
            this._bottom_markings.length + this._markings.length <= 1;
        //много булевых графиков с отображением и нет основных данных
        const not_series_and_many_boolean = series.length == 0 &&
            this._bottom_markings.length + this._markings.length > 1;
        //
        if (one_boolean_on_main || not_series_and_many_boolean) {
            this._element.find('.ui-time-graph').css({ display: 'none' });
            return;
        }
        //данное условие должно выполниться только в том случае, если у нас (нет булевых графиков и series пустой)
        // отрисуем как бы "заглушку"
        if (series.length == 0) {
            series = [{ data: [[0, 0]] }];
        }
        options = this.customizePlot(series, options);
        const grid_markings = this.getGridMarkings([
            ...this._bottom_markings,
            ...this._markings,
        ]);
        $.extend(options, {
            series: { curvedLines: { active: true } },
            grid: {
                ...options.grid,
                markings: this._bool_graph_on_main &&
                    this._bottom_markings.length + this._markings.length === 1
                    ? grid_markings
                    : [],
            },
        });
        if (this._plotElement)
            this._plot = $.plot(this._plotElement, series, options);
        if (this._plot)
            this._canvas = $(this._plot.getCanvas());
    };
    _getBooleanYAxisSize = () => {
        if (!this._booleanPlot) {
            return;
        }
        if (!this._booleanPlotElement?.width() || !this._booleanPlotElement?.height()) {
            return;
        }
        let max_x = null, max_y = null, min_x = null, min_y = null;
        for (const axis of this._booleanPlot.getYAxes()) {
            if (axis.box && (axis.show || axis.reserveSpace)) {
                if (min_x == null || axis.box.left < min_x) {
                    min_x = axis.box.left;
                }
                if (min_y == null || axis.box.top < min_y) {
                    min_y = axis.box.top;
                }
                if (max_x == null || axis.box.left + axis.box.width > max_x) {
                    max_x = axis.box.left + axis.box.width;
                }
                if (max_y == null || axis.box.top + axis.box.height > max_y) {
                    max_y = axis.box.top + axis.box.height;
                }
            }
        }
        return { max_x, max_y, min_x, min_y };
    };
    _setBooleanYAxis = (yaxis) => {
        const size = this._getBooleanYAxisSize();
        if (!size) {
            return;
        }
        const { max_x, max_y, min_x, min_y } = size;
        yaxis.css({
            //@ts-ignore
            display: 'flex',
            flexDirection: 'column',
            // flexDirection: 'column-reverse',
            justifyContent: 'center',
            left: min_x,
            top: min_y,
            width: this._left_margin_for_boolean != 0
                ? this._left_margin_for_boolean - 2
                : 25,
            height: max_y != null && min_y != null ? max_y - min_y : null,
        });
    };
    _draw_bottom_markings = (plot, ctx) => {
        const yaxis = this._element?.find('.ui-boolean-yaxis').empty();
        //массив, чтобы собрать все данные в одном месте
        const items = [];
        //заполняем наш массив
        for (const element of this._bottom_markings) {
            items.push(element);
        }
        for (const element of this._markings) {
            items.push(element);
        }
        if (items.length === 0) {
            return;
        }
        //найдем величину времени по х для всего графика
        const total_length_graph_x = this._viewport
            ? this._viewport[1] - this._viewport[0]
            : null;
        this._setBooleanYAxis(yaxis);
        const xaxis = plot.getAxes().xaxis;
        ctx.save();
        const offset = plot.getPlotOffset();
        ctx.translate(offset.left, offset.top);
        const graph_width = plot.width();
        const graph_height = plot.height();
        //считаем расстояние, которое можно выделить на каждую линию
        const height_container_line = graph_height / items.length;
        //считаем расстояние от самой линии до границы контейнера для этой линии
        const height_padding_line = (height_container_line - this._size_boolean_line) / 2;
        ////
        let y_offset = 0;
        for (const { data, color } of items) {
            for (const item of data) {
                if (!item) {
                    continue;
                }
                let xl = xaxis.p2c(item.xaxis.from);
                let xr = xaxis.p2c(item.xaxis.to);
                if (xr < 0 || xl > graph_width) {
                    continue;
                }
                const total_length_item = xr - xl;
                //когда у нас выбрано несколько дней, то при таком большом маштабе некоторые линии могут пропадать
                //мы сравниваем длину линии (время) с длиной всего графика (временем),
                //если оно меньше какой то части (1е-8), то увеличиваем на 1,
                //тем самым наш элемент будет виден
                if (total_length_graph_x && total_length_item) {
                    const item_part_total = total_length_item / total_length_graph_x;
                    if (item_part_total < 1e-8) {
                        xl = xl - 1;
                        xr = xr + 1;
                    }
                }
                xl = Math.max(xl, 0);
                xr = Math.min(xr, graph_width);
                ctx.fillStyle = item.color;
                ctx.fillRect(xl, y_offset + height_padding_line, xr - xl, this._size_boolean_line);
            }
            y_offset += height_container_line;
            const elem = $(`<div class='ui-boolean-yaxis-container'>
                    <div class='ui-boolean-yaxis-item' legend-type="markings"></div>
                </div>`)
                .css({ height: height_container_line })
                .appendTo(yaxis);
            elem.find('.ui-boolean-yaxis-item').css({
                backgroundColor: color ?? 'black',
                width: this._size_boolean_line,
                height: this._size_boolean_line,
            });
        }
        ctx.restore();
    };
    _realBooleanPlot = () => {
        //@ts-ignore
        const theme = window._ui?.getUITheme();
        //конфиг для булевых графиков
        const options = {
            xaxis: {
                mode: 'time',
                //@ts-ignore
                min: this._viewport[0],
                //@ts-ignore
                max: this._viewport[1],
                color: theme != null
                    ? theme.palette.mode === 'dark'
                        ? theme.palette.grey['600']
                        : '#e4e4e4'
                    : '#e4e4e4',
                font: theme != null
                    ? {
                        ...this.axes_font,
                        color: theme.palette.mode === 'dark'
                            ? theme.palette.text.secondary
                            : '#545454',
                    }
                    : this.axes_font,
                tickFormatter: (time, axis) => {
                    const d = new Date(time);
                    const p = axis._prev;
                    axis._prev = d;
                    if (p && d > p.getTime()) {
                        if (d.getFullYear() - 1900 == p.getFullYear() - 1900 &&
                            d.getMonth() == p.getMonth() &&
                            d.getDate() == p.getDate() &&
                            p.getTime() > axis.min)
                            if (d.getHours() == p.getHours() &&
                                d.getMinutes() == p.getMinutes())
                                return '';
                            else
                                return rusTimeOnly(d);
                        else
                            return rusTimeDateBr(d);
                    }
                    else
                        return rusTimeDateBr(d);
                },
            },
            yaxis: {
                font: theme != null
                    ? {
                        ...this.axes_font,
                        color: theme.palette.mode === 'dark'
                            ? theme.palette.text.secondary
                            : '#545454',
                    }
                    : this.axes_font,
            },
            yaxes: [],
            grid: {
                margin: 0,
                borderWidth: 0,
                hoverable: true,
                clickable: is_touch,
                autoHighlight: false,
                backgroundColor: theme != null && theme.palette.mode === 'dark' ? '#545454' : '#fff',
            },
            crosshair: {
                mode: 'x',
                color: theme != null ? theme.palette.primary.dark : '#007d99',
                lineWidth: 1.5,
                locked: true,
                intermittent: true,
            },
            selection: {
                mode: 'x',
                color: '#4e9dd5',
                filter_func: (e) => {
                    return e.ctrlKey || this.selection_mode();
                },
                on_selection_start: () => {
                    this._booleanPlotElement?.addClass('selecting');
                },
                on_selection_stop: () => {
                    this._booleanPlotElement?.removeClass('selecting');
                },
            },
        };
        const series = [{ data: [[0, 0]] }];
        //сдвиг булевых графиков
        // проверяем, есть ли в нашем блоксете основные(линейные) графики.
        // если такие графики есть, то _left_margin_for_boolean будет отличен от нуля
        // значение данной переменно определяется в файле index (функция: set_yaxes_full_width)
        // берем его и задаем как отступ для булевых графиков
        // самое главное, что это будет работать для смены обозначений по оси Y !!!!
        if (this._left_margin_for_boolean != 0) {
            options.yaxes = [
                {
                    show: false,
                    labelWidth: this._left_margin_for_boolean - 2,
                    reserveSpace: true,
                },
            ];
        }
        // если у нас в блоксете нет основных графиков, то будем задавать отступ числом 24, чтобы наш timeline сошелся с булевыми графиками
        // понять сложно и тяжело, но оно работает
        else {
            options.yaxes = [{ show: false, labelWidth: 24, reserveSpace: true }];
        }
        $.extend(options, {
            hooks: {
                draw: [this._draw_bottom_markings],
            },
        });
        let height_boolean = 0;
        if (this._bottom_markings.length + this._markings.length != 0) {
            height_boolean =
                (this._bottom_markings.length + this._markings.length) *
                    this._size_boolean_line *
                    1.8 +
                    30;
        }
        else {
            height_boolean = 40;
        }
        this._booleanPlotElement.css('height', height_boolean);
        this._booleanPlot = $.plot(this._booleanPlotElement, series, options);
    };
    plot = () => this._plot;
    _onWheel = (event) => {
        if (!this._wheel_zoom && !event.ctrlKey) {
            return true;
        }
        let pos = null;
        if (this._plot || this._booleanPlot)
            pos = this._coordsByMouse(event);
        if (pos) {
            this._zoomStep(event.originalEvent.deltaY / 53, pos.x, {
                pageX: event.pageX,
                pageY: event.pageY,
                x: pos.x,
                y: pos.y,
            });
        }
        event.preventDefault();
        return;
    };
    _zoomStep = (zoomFactor, center, position) => {
        if (this._viewport) {
            const old_l = this._viewport[0];
            const old_r = this._viewport[1];
            const width = old_r - old_l;
            let newwidth = width * Math.pow(this._zoom_factor, zoomFactor);
            if (this._bounds)
                newwidth = Math.min(newwidth, this._bounds[1] - this._bounds[0]);
            if (!center)
                center = parseInt(((old_r + old_l) / 2).toString(), 10);
            const new_l = center - ((center - old_l) * newwidth) / width;
            const new_r = center + ((old_r - center) * newwidth) / width;
            if ((new_l != old_l || new_r != old_r) && this._view_port_change) {
                this._view_port_change([new_l, new_r], position);
                if (this._interaction_end)
                    this._interaction_end();
                return true;
            }
            else
                return false;
        }
        return;
    };
    _onSelected = (event, ranges) => {
        if (this._view_port_change)
            if (ranges.position) {
                this._view_port_change([ranges.xaxis.from, ranges.xaxis.to], ranges.position);
            }
            else {
                this._view_port_change([ranges.xaxis.from, ranges.xaxis.to]);
            }
        if (this._interaction_end)
            this._interaction_end();
    };
    _onHover = (plotevent, position, dataitem) => {
        if (this._set_hover) {
            this._set_hover(parseInt((position.x / 1000).toString(), 10), {
                pageX: position.pageX,
                pageY: position.pageY,
                x: position.x,
                y: position.y,
            });
        }
    };
    _onUnhover = () => {
        if (this._set_unhover)
            this._set_unhover();
    };
    _coordsByMouse = (mouseevent) => {
        if (this._plot) {
            const canvasOffset = this._canvas?.offset();
            const plotOffset = this._plot.getPlotOffset();
            if (canvasOffset) {
                const canvasX = mouseevent.pageX - canvasOffset.left - plotOffset.left;
                const canvasY = mouseevent.pageY - canvasOffset.top - plotOffset.left;
                return this._plot.c2p({ left: canvasX, top: canvasY });
            }
        }
        if (this._booleanPlot) {
            const canvasOffset = $(this._booleanPlot.getCanvas())?.offset();
            const plotOffset = this._booleanPlot.getPlotOffset();
            if (canvasOffset) {
                const canvasX = mouseevent.pageX - canvasOffset.left - plotOffset.left;
                const canvasY = mouseevent.pageY - canvasOffset.top - plotOffset.left;
                return this._booleanPlot.c2p({ left: canvasX, top: canvasY });
            }
        }
        return null;
    };
    _touchStart = (touch_id, touch_x, touch_y) => {
        let pos = null;
        if (this._plot || this._booleanPlot) {
            pos = this._coordsByMouse({ pageX: touch_x, pageY: touch_y });
        }
        if (!pos)
            return;
        this._object_touches[touch_id] = {
            x: touch_x,
            y: touch_y,
            ox: touch_x,
            oy: touch_y,
            pos: pos,
        };
        if (this._interaction_start)
            this._interaction_start();
    };
    _touchUpdate = (event) => {
        const touches_keys = Object.keys(this._object_touches);
        const object_touch_cnt = touches_keys.length;
        if (object_touch_cnt == 1) {
            const touch = this._object_touches[touches_keys[0]];
            let new_pos = null;
            const dx = touch.x - touch.ox;
            const dy = touch.y - touch.oy;
            if (Math.abs(dy) / Math.abs(dx) > 2) {
                return false;
            }
            if (this._plot || this._booleanPlot) {
                new_pos = this._coordsByMouse({
                    pageX: touch.x,
                    pageY: touch.y,
                });
            }
            if (new_pos) {
                const diff = new_pos.x - touch.pos.x;
                const v = this.viewport();
                if (v && this._view_port_change) {
                    if (event.type === 'touchmove') {
                        this._view_port_change([v[0] - diff, v[1] - diff], {
                            pageX: event.originalEvent.touches[0].pageX,
                            pageY: event.originalEvent.touches[0].pageY,
                        });
                    }
                    else {
                        this._view_port_change([v[0] - diff, v[1] - diff], {
                            pageX: event.pageX,
                            pageY: event.pageY,
                        });
                    }
                }
            }
            return true;
        }
        else if (object_touch_cnt >= 2) {
            let t1 = null, t2 = null;
            for (const key of touches_keys)
                if (this._object_touches[key] !== undefined) {
                    if (t1)
                        t2 = this._object_touches[key];
                    else
                        t1 = this._object_touches[key];
                }
            const old_viewport = this.viewport();
            if (t1 && t2) {
                let p1 = t1.pos.x;
                let p2 = t2.pos.x;
                let n1 = this._coordsByMouse({ pageX: t1.x, pageY: t1.y })?.x;
                let n2 = this._coordsByMouse({ pageX: t2.x, pageY: t2.y })?.x;
                if (p1 > p2) {
                    const t = p1;
                    p1 = p2;
                    p2 = t;
                }
                if (n1 && n2 && old_viewport) {
                    if (n1 > n2) {
                        const t = n1;
                        n1 = n2;
                        n2 = t;
                    }
                    const k = (p1 - p2) / (n1 - n2);
                    const b = p1 - k * n1;
                    const nv1 = k * old_viewport[0] + b;
                    const nv2 = k * old_viewport[1] + b;
                    if (this._view_port_change) {
                        this._view_port_change([nv1, nv2], {
                            pageX: event.originalEvent.touches[0].pageX,
                            pageY: event.originalEvent.touches[0].pageY,
                        });
                        return true;
                    }
                }
            }
        }
        return false;
    };
    _touchEnd = (touch_id) => {
        delete this._object_touches[touch_id];
        window.setImmediate(() => {
            if (this._interaction_end)
                this._interaction_end();
        });
    };
}
